/**
 * Simple Carousel - Swiper.js Integration
 * 
 * Inicializa Swiper para carruseles simples (marcas, testimonios, etc.)
 */

function initSimpleCarousel(carousel) {
  if (!carousel || carousel.swiper) return;

    const columnsDesktop = parseInt(carousel.dataset.columnsDesktop) || 6;
    const columnsMobile = parseInt(carousel.dataset.columnsMobile) || 3;
    const gapDesktop = carousel.dataset.carouselGap !== undefined ? parseInt(carousel.dataset.carouselGap) : 24;
    const gapMobile = carousel.dataset.carouselGapMobile !== undefined ? parseInt(carousel.dataset.carouselGapMobile) : 16;
    const autoplay = carousel.dataset.autoplay === 'true';
    const autoplaySpeed = (parseInt(carousel.dataset.autoplaySpeed) || 3) * 1000;
    const layout = carousel.dataset.layout || 'brands';
    
    // Peek effect settings
    const hasPeek = carousel.dataset.peek === 'true';
    const peekAmount = parseInt(carousel.dataset.peekAmount) || 20;
    const peekAmountMobile = parseInt(carousel.dataset.peekAmountMobile) || 20;
    
    // Obtener el wrapper padre para buscar las flechas
    const wrapper = carousel.closest('.simple-carousel-wrapper');
    const prevEl = wrapper ? wrapper.querySelector('.swiper-button-prev') : null;
    const nextEl = wrapper ? wrapper.querySelector('.swiper-button-next') : null;
    
    // Calculate slidesPerView with peek effect
    const slidesPerViewMobile = hasPeek 
      ? columnsMobile + (peekAmountMobile / 100) 
      : columnsMobile;
    const slidesPerViewDesktop = hasPeek 
      ? columnsDesktop + (peekAmount / 100) 
      : columnsDesktop;
    
    // Configuración base
    const swiperConfig = {
      slidesPerView: slidesPerViewMobile,
      spaceBetween: gapMobile,
      loop: true,
      speed: 500,
      
      breakpoints: {
        1024: {
          slidesPerView: slidesPerViewDesktop,
          spaceBetween: gapDesktop
        }
      },
      
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      }
    };
    
    // Agregar autoplay si está habilitado
    if (autoplay) {
      swiperConfig.autoplay = {
        delay: autoplaySpeed,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      };
    }
    
    // Ajustes específicos por layout
    if (layout === 'testimonials') {
      const testimonialSlidesDesktop = hasPeek 
        ? Math.min(columnsDesktop, 4) + (peekAmount / 100)
        : Math.min(columnsDesktop, 4);
      const testimonialSlidesMobile = hasPeek 
        ? 1 + (peekAmountMobile / 100)
        : 1;
      const testimonialSlidesTablet = hasPeek 
        ? 2 + (peekAmountMobile / 100)
        : 2;
      
      swiperConfig.slidesPerView = testimonialSlidesMobile;
      swiperConfig.breakpoints = {
        550: {
          slidesPerView: testimonialSlidesTablet,
          spaceBetween: gapMobile
        },
        1024: {
          slidesPerView: testimonialSlidesDesktop,
          spaceBetween: gapDesktop
        }
      };
    }
    
    new Swiper(carousel, swiperConfig);
}

function observeSimpleCarousels() {
  const carousels = document.querySelectorAll('.simple-carousel');

  if (window.Shopify && window.Shopify.designMode) {
    carousels.forEach(initSimpleCarousel);
    return;
  }

  if (!('IntersectionObserver' in window)) {
    requestAnimationFrame(() => carousels.forEach(initSimpleCarousel));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      delete entry.target.dataset.simpleCarouselWatch;
      initSimpleCarousel(entry.target);
    });
  }, {
    rootMargin: '250px 0px',
    threshold: 0
  });

  carousels.forEach((carousel) => {
    if (carousel.swiper || carousel.dataset.simpleCarouselWatch === 'true') return;
    carousel.dataset.simpleCarouselWatch = 'true';
    observer.observe(carousel);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', observeSimpleCarousels);
} else {
  observeSimpleCarousels();
}

document.addEventListener('shopify:section:load', observeSimpleCarousels);
